module.exports = __webpack_public_path__ + "static/fonts/text-security-disc-compat.6d45019.ttf";